import { useMemo, forwardRef, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
// @ts-expect-error this file isn't typed
import { ThreadViewStoreSingleton } from '../../ThreadViewStoreSingleton';
import { jsx as _jsx } from "react/jsx-runtime";
let keyCounter = 0;
export const provideThreadView = WrappedComponent => {
  const ProvideThreadView = /*#__PURE__*/forwardRef((props, ref) => {
    // ensure that if the component is mounted before the store
    // is initailized, it'll get re-rendered if the store is
    // initialized
    const uniqueKey = useMemo(() => `${keyCounter++}`, []);
    const store = ThreadViewStoreSingleton.getInstance();
    const [, setInitialized] = useState(Boolean(store));
    useEffect(() => {
      ThreadViewStoreSingleton.subscribeToInit(uniqueKey, () => setInitialized(true));
      return () => ThreadViewStoreSingleton.unsubscribeToInit(uniqueKey);
    }, [uniqueKey]);
    return store ? /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
        ref: ref
      }, props))
    }) : null;
  });
  ProvideThreadView.displayName = 'ProvideThreadView';
  return ProvideThreadView;
};